import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
	addEventAttribute,
	adminEventCard, audienceButtons,
	setUniqueEventAttribute,
	smallEventCard,
	smallSchemaArtistCard,
	toastSuccess
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";

function classNames(...classes: any[]) {
	return classes.filter(Boolean).join(' ')
}

export default function Addscriptstosite() {
	const navigate = useNavigate();
	const logout = () => {
		window.location.href = '/logout';
	}



	type SchemaArtist = {
		[key: string]: any; // ?? variable key
		name: string;
	};
const [artistData, setArtistData] = useState<SchemaArtist>();

	var date = new Date();
	const stopBouncing = () => {
		const el = document.getElementById("promo-icon");
		if (el) {
			el.classList.remove("animate-bounce");
		}
	}

	useEffect(() => {
		setTimeout(() => stopBouncing(), 3500)
		//getPhotos();

	}, []);

	return (<>
		{/*
        This example requires updating your template:

        ```
        <html class="h-full">
        <body class="h-full">
        ```
      */}
		<div className="min-h-full dark:bg-white bg-white">
			<div className="lg:pl-8">

				<main className="p-1">
					<div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
						<div className="flex">
							<img id="promo-icon"
								 className="h-16 w-auto animate-bounce"
								 src="https://media.promogogo.com/ymsirvidburdir/2025-03-13/ymsirvidburdir-78662c7e-34ad-47cd-83fe-f73fbea5e36b-promo_heart_yellow_256px.png"
								 alt="Promogogo"/>
						</div>
						<h2 className="text-3xl font-bold tracking-tight mt-4 text-gray-900 sm:text-4xl">
							How to add our stuff
							<br/>
							to your stuff.
						</h2>
						<div className="mt-10">
							<h3 className="text-xl font-semibold text-gray-900">Just copy and paste</h3>

							<p className="mt-2 p-2 text-lg text-gray-600">
								We've tried to keep this as basic as possible. Just add the DIVs and the scripts to your site, placing the DIVs where you want the content to appear.
							</p>

						</div>
						<div className="mt-10">
							<h3 className="text-xl font-semibold text-gray-900">The BODY section</h3>
							<p className="mt-2 text-lg text-gray-600">
								Our scripts inject content in a div element with a specific ID. You can place this div anywhere in the BODY section of your site.
							</p>
							<div className="mt-6 bg-gray-100 p-4 rounded-md">
							<pre className="text-sm font-mono text-gray-900">
								{`<section class="segment" id="gjugg-vidburdir-main"></section>
`}
							</pre>
							</div>
							<p className="mt-2 text-lg text-gray-600">
								At the bottom of the page add the following code.
							</p>
							<p className="mt-2 text-lg text-gray-600">
								First, we rely on jQuery to be present. If it isn't in scope add it.
							</p>
							<div className="mt-6 bg-gray-100 p-4 rounded-md">
							<pre className="text-sm font-mono text-gray-900">
								{`<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>`}
							</pre>
							</div>
							<div className="mt-6 bg-gray-100 p-4 rounded-md">
							<pre className="text-sm font-mono text-gray-900">
								{`<link rel="stylesheet" type="text/css" href="/scripts/plugins/3rdparty/bootstrap/vidburdir.css" />

<script type="module" src="/scripts/plugins/abroad/abroadscripts.js" id="gogoscript" 
data-partner="icelandmusic" data-country="IS"></script>`}
							</pre>
							</div>
							<p className="mt-2 text-lg text-gray-600">
								<img src={'https://media.promogogo.com/ymsirvidburdir/2025-03-13/ymsirvidburdir-50844680-e832-41dd-a3e8-30252ebf54b3-iceland-music-list.png'}
									 className={'w-9/12'} alt={'Icelandic artists abroad'}/>
								This example will render a list of Icelandic artists playing abroad.
							</p>

						</div>



					</div>
				</main>
			</div>
		</div>


	</>)
}
